import {DeviceHardwareState} from "../types";
import {Reducer} from "redux";
import {initializeCapabilities, initializeDeviceHardware, selectDeviceHardware} from "../routines";

const deviceHardwareState: DeviceHardwareState = {
  selectedDeviceHardwareId: 0,
  deviceHardwares: [],
  capabilities: []
};

const deviceHardware: Reducer<DeviceHardwareState> = (state: DeviceHardwareState = deviceHardwareState, action) => {
  switch (action.type) {
    case selectDeviceHardware.SUCCESS:
      return {
        ...state,
        selectedDeviceHardwareId: action.payload
      };

    case initializeDeviceHardware.SUCCESS:
      return {
        ...state,
        deviceHardwares: action.payload
      }

    case initializeCapabilities.SUCCESS:
      return {
        ...state,
        capabilities: action.payload
      }

    default:
        return state;
  }
};

export default deviceHardware;
